/* eslint-disable */
import moment from 'moment';
import 'daterangepicker/daterangepicker';

function handlerKeydown() {
  const keydownClass = 'date-focus';
  const datepickerBlock = document.querySelector('.daterangepicker');

  let activeElement;

  activeElement = document.activeElement;
  activeElement.classList.add(keydownClass);

  datepickerBlock.addEventListener('keyup', (event) => {

    if ([37, 38, 39, 40, 32].includes(event.which)) {

      activeElement = document.activeElement;
      if (activeElement.closest('.daterangepicker')) {
        activeElement.classList.add(keydownClass);
      }

    }
  });

  datepickerBlock.addEventListener('keydown', () => {
    activeElement = document.activeElement;

    if(activeElement.classList.contains(keydownClass)) {
      activeElement.classList.remove(keydownClass);
    }
  });
}

function getDayDate(el) {
  let dayOfMonth = parseInt(el.innerText);
  let nameOfmonth = el.closest('table').getElementsByClassName('month');
  let elementDayDate = new Date(dayOfMonth + ' ' + nameOfmonth[0].innerText);

  return elementDayDate;
}

function adjustCellsMonthes(datesElements) {
  let startOfMonthes = 0;
  datesElements.forEach((el) => {
    let currentMonth;
    const elementDayDate = getDayDate(el);

    if (el.innerText === '1') {
      startOfMonthes++;
    }

    if (el.innerText !== 1) {
      if (startOfMonthes === 0) {
        currentMonth = elementDayDate.getMonth() - 1;
      } else if (startOfMonthes === 1) {
        currentMonth = elementDayDate.getMonth();
      } else {
        currentMonth = elementDayDate.getMonth() + 1;
      }
    }

    el.setAttribute('month', currentMonth);
  });

  startOfMonthes = 0;
}

function generateDateLabel(elementDayDate, postfix = '', prefix = true) {
  const weekDays = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  const monthNames = [
    "January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
  ];

    // Date Friday, October 18, 2024
    return (prefix ? 'Date ' : '') + weekDays[elementDayDate.getDay()] + ' ' + monthNames[elementDayDate.getMonth()]
      + ' ' + elementDayDate.getDate() + ' ' + elementDayDate.getFullYear() + postfix;
}

function addAriaLabelToDays(datesElements, args, postfix = '') {
  datesElements.forEach((el) => {
    const elementDayDate = getDayDate(el);
    elementDayDate.setMonth(el.getAttribute('month'))
    const dateLabel = generateDateLabel(elementDayDate, postfix);

    if (args.dateType === 'expired') {
      if (args.currentDayDate.valueOf() > elementDayDate.valueOf()) {
        el.classList.add('expired');
        el.ariaLabel = dateLabel;
      }
    }else {
      el.ariaLabel = dateLabel;
    }

    el.setAttribute('tabIndex', '0');
    el.role = 'application';
  });
}

function addAriaLabelToEndDate(closeDataElement) {
  let month = document.querySelector('.drp-calendar.left table') ?
    document.querySelector('.drp-calendar.left table').getElementsByClassName('month')
    : "undefined";
  let applyButton = document.querySelector('.applyBtn');
  if (closeDataElement && typeof month !== "undefined") {
    const selectedField = document.querySelector('.drp-selected').innerText;
    const firstYear = month[0].innerText.match(/\d+/)[0];
    let selectedDates = selectedField.split(' - ');
    for( let i in selectedDates){
      selectedDates[i] = selectedDates[i].split('/');
    }

    const dateStart = new Date();
    dateStart.setMonth(selectedDates[0][0] - 1)
    dateStart.setFullYear(firstYear)
    dateStart.setDate(selectedDates[0][1]);

    const dateEnd = new Date();
    dateEnd.setMonth(selectedDates[1][0] - 1)
    dateEnd.setFullYear(selectedDates[1][0] > selectedDates[1][0] ? firstYear + 1 : firstYear)
    dateEnd.setDate(selectedDates[1][1])

    const dataStartLabel = generateDateLabel(dateStart, '', false);
    const dataEndLabel = generateDateLabel(dateEnd, '', false);

    applyButton.ariaLabel = 'Apply currently selected dates: ' + dataStartLabel + ' to ' + dataEndLabel;
  }
}

function prepareAdaDaysCols() {
  const currentDayDate = new Date().setHours(0, 0, 0, 0);
  const allLeftTds = document.querySelectorAll('.daterangepicker .drp-calendar.left td');
  const allRightTds = document.querySelectorAll('.daterangepicker .drp-calendar.right td');
  const availableDates = document.querySelectorAll('.daterangepicker td.available:not(.close)');
  const expiredDates = document.querySelectorAll('.daterangepicker td:not(.available):not(.available.close)');
  const unavailableDates = document.querySelectorAll('.daterangepicker td.available.close');
  const closeDate = document.querySelector('.daterangepicker td.end-date');

  adjustCellsMonthes(allLeftTds);
  adjustCellsMonthes(allRightTds);
  addAriaLabelToDays(availableDates, {currentDayDate, dateType: 'available'})
  addAriaLabelToDays(expiredDates, {currentDayDate, dateType: 'expired'}, ', Date Expired');
  addAriaLabelToDays(unavailableDates, {currentDayDate, dateType: 'unavailable'}, ', Date unavailable for selection')
  addAriaLabelToEndDate(closeDate);

  unavailableDates.forEach((el) => {
    el.classList.add('disabled');
    el.classList.remove('available');
    el.ariaDisabled = true;
  });
}

function prepareAdaArrows() {
  const availableNext = document.querySelector('.c-daterangepicker .calendar-table th.next.available');
  const availablePrev = document.querySelector('.c-daterangepicker .calendar-table th.prev.available');

  if (availableNext){
    availableNext.ariaLabel = 'Button next month';
    availableNext.setAttribute('tabIndex', 0);
    availableNext.setAttribute('role', 'application');
  }

  if (availablePrev) {
    availablePrev.ariaLabel = 'Button previous month';
    availablePrev.setAttribute('tabIndex', 0);
    availablePrev.setAttribute('role', 'application');
  }
}

function prepareAdaTable() {
  const tHeaders = document.querySelectorAll('.daterangepicker thead tr:nth-child(2) th, .daterangepicker thead th.month');
  const tables = document.querySelectorAll('.daterangepicker table');
  const tData = document.querySelectorAll('.daterangepicker td');

  tHeaders.forEach(el => {
    el.setAttribute('scope', 'col');
  })

  tData.forEach(el => {
    el.setAttribute('scope', 'row');
  })

  tables.forEach(el => {
    el.setAttribute('role', 'presentation')
  })
}

function updateButtonAvailability() {
  prepareAdaDaysCols();
  prepareAdaArrows();
  prepareAdaTable();
};

(function ($) {
  let data;
  let $dateRangeSelector;
  const bookingAvailabilityDateStatusMap = {};
  const loadedDatesResponsesCache = {};
  let loadingDates = false;
  let lastRequestedDate;
  let dateSelector;
  let destinationSelector;

  $(document).ready(() => {

    if (!$('.booking-widget__submit').data()) {
      return;
    }

    initData();
    initDateRangePicker();

    $('.booking-widget__date-selector').on('keypress', (event) => {
      if ([13, 32].includes(event.which)) {
        togglePicker();
      }

      event.preventDefault();
    });

    $('body').on('keydown', '.daterangepicker', (e) => {
      if (e.which === 27) {
          $('.daterangepicker .cancelBtn').trigger('click');
      }
    })

    $('body').on('click', '.daterangepicker .cancelBtn, .daterangepicker .applyBtn', () => {
      $('.booking-widget__date-selector').trigger('focus');
    });

    if (bookingWidgetType === 'room-widget') {
      dateSelector.addEventListener('click', togglePicker);
    }
    $('.booking-widget__form').on('submit', onSubmit);
    $('[id^="destination-selector"]').parent('.c-custom-select').find('.c-custom-select__option').on('click', refreshHotelData);
    destinationSelector.addEventListener('keypress', (event) => {
      if (event.keyCode === 13) {
        destinationSelector.querySelector('.c-custom-select__selected').click();
      }
    });
    destinationSelector.querySelector('.c-custom-select__selected').tabIndex = -1;
  });

  function initDateRangePicker() {
    dateSelector.closest('.booking-widget').querySelector('.booking-widget__start-date').textContent = `${data.start.format('MMM D')} / ${data.end.format('MMM D')}`;

    const picker = $dateRangeSelector.daterangepicker({
      parentEl: document.getElementsByClassName('booking-widget__calendar-parent')[0],
      singleDatePicker: isSingle(),
      autoUpdateInput: true,
      startDate: data.start,
      endDate: data.end,
      minDate: new Date(),
      opens: 'left',
      locale: daterangeLocale,
      cancelButtonClasses: 'cancelBtn c-button c-button--blue c-loop-focus__close',
      applyButtonClasses: 'applyBtn c-button c-button--blue',
      isCustomDate: bookingWidgetType === 'room-widget' ? beforeShowDay : null,
    }, (pickerStartDate, pickerEndDate) => {
      data.start = pickerStartDate;
      data.end = pickerEndDate;
    }).data('daterangepicker');

    picker.container.addClass('c-daterangepicker c-loop-focus');
    picker.container.attr('role', 'dialog');

    picker.container.find('.drp-calendar')
      .on('change.daterangepicker', 'select.yearselect', () => {
        prepareAdaArrows()
      })
      .on('change.daterangepicker', 'select.monthselect', () => {
        prepareAdaArrows()
      })

    // Find the element using jQuery
    var calendarLeft = picker.container.find('.drp-calendar.left .calendar-table').get(0); // Get the DOM element
    var calendarRight = picker.container.find('.drp-calendar.right .calendar-table').get(0); // Get the DOM element

// Create a MutationObserver instance
    var observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'childList' || mutation.type === 'subtree') {
          updateButtonAvailability();
        }
      });
    });

// Set up the observer configuration
    var config = { childList: true, subtree: true }; // Detect changes in children and subtree

// Start observing the target element
    if (calendarLeft) {
      observer.observe(calendarLeft, config);
    }
    if (calendarRight) {
      observer.observe(calendarRight, config);
    }

    $dateRangeSelector.off('focus.daterangepicker');
    $dateRangeSelector.on('hide.daterangepicker', (event) => {
      dateSelector.classList.remove('show');
    });
    $dateRangeSelector.on('show.daterangepicker', (event) => {
      $('.daterangepicker button, .daterangepicker th.next.available, .daterangepicker th.prev.available, .daterangepicker td.today, .daterangepicker td.start-date').attr('tabindex', 0);
      const day = $('.daterangepicker td:not(.off)');
      $(day.get(0)).focus();

      handlerKeydown();
    });
    $dateRangeSelector.on('showCalendar.daterangepicker', (event) => {
      $('.daterangepicker td:not(.disabled)').attr('tabindex', 0);
      $('.daterangepicker .applyBtn, .daterangepicker .cancelBtn ').attr('tabindex', 0);
      $('.daterangepicker button, .daterangepicker th.next.available, .daterangepicker th.prev.available').attr('tabindex', 0);
    });
    $dateRangeSelector.on('apply.daterangepicker', onApplyDate);
    $dateRangeSelector.on('apply.daterangepicker', function () {
      dateSelector.closest('.booking-widget').querySelector('.booking-widget__start-date').textContent = `${data.start.format('MMM DD')} / ${data.end.format('MMM DD')}`;
    })

    if (bookingWidgetType === 'room-widget') {
      showRoomAvailabilityLegend(picker);
      $dateRangeSelector.off('click.daterangepicker');
      $dateRangeSelector.on('click.daterangepicker', () => {
        togglePicker();
      });
    }
  }

  function isSingle() {
    return $('.booking-widget__daterange').length < 1;
  }

  function initData() {
    $dateRangeSelector = $('.booking-widget__option--daterange');
    data = $('.booking-widget__submit').data();
    dateSelector = document.querySelector('.booking-widget__date-selector');
    destinationSelector = document.querySelector('#destination-selector').parentElement.parentElement;
    data.start = moment(data.start, data.dateFormat);
    data.end = moment(data.end, data.dateFormat);
  }

  function onApplyDate(ev, picker) {
    data.start = picker.startDate;
    data.end = picker.endDate;
  }

  function togglePicker() {
    if (bookingWidgetType === 'room-widget') {
      loadAvailabilitiesForCurrentFormState(
        null,
        () => {
          // Reinit daterangepicker after dates load
          initDateRangePicker();
          $dateRangeSelector.data('daterangepicker').toggle();
          // Prevent window close on dates loading
          $(document).off('mousedown.daterangepicker');
          $(document).on('mousedown.daterangepicker', (e) => {
            if (loadingDates) {
              e.stopPropagation();
            } else {
              $dateRangeSelector.data('daterangepicker').outsideClick(e);
            }
          });
          $dateRangeSelector.off('click.daterangepicker');
          $dateRangeSelector.on('click.daterangepicker', () => {
            togglePicker();
          });
        },
      );
      initDateRangePicker();

      setTimeout(updateButtonAvailability);
    }

    if (dateSelector.classList.contains('show')) {
      $dateRangeSelector.data('daterangepicker').hide();
    } else {
      $dateRangeSelector.data('daterangepicker').toggle();
    }

    // Prevent window close on dates loading
    $(document).off('mousedown.daterangepicker');
    $(document).on('mousedown.daterangepicker', (e) => {
      if (loadingDates) {
        e.stopPropagation();
      } else {
        $dateRangeSelector.data('daterangepicker').outsideClick(e);
      }
    });
    $dateRangeSelector.off('click.daterangepicker');
    $dateRangeSelector.on('click.daterangepicker', () => {
      togglePicker();
    });
    dateSelector.classList.toggle('show');
  }

  function onSubmit(event) {
    const destination = $('#destination-selector').find(':selected');
    const adults = 2;
    const children = 0;
    const rooms = 1;

    if (data.provider === 'azds-booking') {
      if ($(window).width() < 992) {
        window.location.href = destination.data('url').replace('step-2', 'step-1');
      } else {
        window.location.href = `${destination.data('url')}?${$.param({
          arrive: data.start.format(data.bookingFormat),
          depart: data.end.format(data.bookingFormat),
          adults,
          children,
          rooms,
        })}`;
      }
    }

    event.preventDefault();
  }

  function refreshHotelData(e) {
    if (typeof roomWidgetSettings === 'undefined' || roomWidgetSettings === null) {
      return;
    }

    const destinationSelected = $('#destination-selector').find(':selected');
    $('#destination-value').html(destinationSelected.text());
    const hotelSettings = roomWidgetSettings[destinationSelected.val()];
    dateSelector.focus();
    if (!hotelSettings) {
      return;
    }
    resetBookingAvailabilityDateStatusMap();
  }

  function beforeShowDay(date) {
    // ignore possible dates from previous month in the beginning of calendar
    if (lastRequestedDate
      && (date >= moment(lastRequestedDate).subtract(6, 'days').toDate()
        && date < moment(lastRequestedDate))) {
      return false;
    }

    const hotel = $('#destination-selector').find(':selected').data('site');
    if (bookingAvailabilityDateStatusMap[hotel] && bookingAvailabilityDateStatusMap[hotel][date.format('YYYY-MM-DD')]) {
      return bookingAvailabilityDateStatusMap[hotel][date.format('YYYY-MM-DD')];
    }
    // Load if dates unavailable
    loadAvailabilitiesForCurrentFormState(date.format('YYYY-MM-DD'));
    return false;
  }

  function loadAvailabilitiesForCurrentFormState(requestedDate, callbackOnLoaded) {
    if (moment(requestedDate).startOf('month').toDate() < moment().startOf('month').toDate()) {
      return;
    }

    const data = $('.booking-widget__submit').data();
    // 6 days to ignore dates from previous month in the beginning of calendar
    const backDirection = (lastRequestedDate && requestedDate)
      ? moment(lastRequestedDate).subtract(6, 'days').toDate() > moment(requestedDate).toDate() : false;
    const destination = $('#destination-selector').find(':selected');
    const hotel = destination.data('site');

    const adults = 2;
    const children = 0;
    const fromDateMoment = requestedDate
      ? (backDirection ? moment(requestedDate).subtract(3, 'M').startOf('month') : moment(requestedDate).startOf('month'))
      : moment(data.start).startOf('month');
    const fromDate = fromDateMoment.format('YYYY-MM-DD');
    const toDateMoment = fromDateMoment.add(5, 'M').endOf('month');
    const toDate = toDateMoment.format('YYYY-MM-DD');

    loadAvailabilities(
      hotel,
      fromDate,
      toDate,
      adults,
      children,
      callbackOnLoaded,
    );
  }

  function loadAvailabilities(hotelCode, from, to, adults, children, callbackOnLoaded) {
    const hotel = hotelCode;
    const url = `${bookingApiBaseUri + hotel}/calendar?from=${from}&to=${to}&adults=${adults}&children=${children}&autoscroll=1&ttl=6`;

    if (loadedDatesResponsesCache[url]) {
      setBookingAvailabilityDateStatusMapByResponse(hotel, loadedDatesResponsesCache[url]);
      return;
    }

    if (loadingDates) {
      return;
    }

    loadingDates = true;
    lastRequestedDate = from;
    $('.booking-widget').addClass('dates-loading');
    $.get(
      url,
      (data) => {
        setBookingAvailabilityDateStatusMapByResponse(hotel, data.availabilities);
        loadedDatesResponsesCache[url] = data.availabilities;
        loadingDates = false;
        $('.booking-widget').removeClass('dates-loading');
        $dateRangeSelector.data('daterangepicker').updateCalendars();
        setTimeout(() => {
          const sDate = $('.daterangepicker td.start-date:not(.close), .daterangepicker td.available:not(.close)');
          const target = $(sDate.length ? '.daterangepicker td.start-date' : '.daterangepicker .next');
          $('.daterangepicker button, .daterangepicker th.next.available, .daterangepicker th.prev.available, .daterangepicker td.available.open:not(.off)').attr('tabindex', 0);
          $(target.get(0)).focus();
          $('.daterangepicker td.available.close').attr('aria-disabled', 'true').addClass('disabled').removeClass('available');
        }, 100);

        if (callbackOnLoaded) {
          callbackOnLoaded();
        }
      },
    ).fail((e) => {
      if (e.status == 400) {
        const availabilities = [{
          from,
          to,
          status: 'close',
        }];
        setBookingAvailabilityDateStatusMapByResponse(hotel, availabilities);
        loadedDatesResponsesCache[url] = availabilities;
        loadingDates = false;
        $('.booking-widget').removeClass('dates-loading');
        $dateRangeSelector.data('daterangepicker').updateCalendars();
        if (callbackOnLoaded) {
          callbackOnLoaded();
        }
      } else {
        loadingDates = false;
        $('.booking-widget').removeClass('dates-loading');
        initDateRangePicker();
      }
    });
  }

  function setBookingAvailabilityDateStatusMapByResponse(hotel, availabilities) {
    availabilities.forEach((availability) => {
      const fromDate = moment(availability.from);
      const toDate = moment(availability.to);
      for (let m = moment(fromDate); m.diff(toDate, 'days') <= 0; m.add(1, 'days')) {
        let status = 'open';
        switch (availability.status) {
          case 'open':
            status = 'open';
            break;
          case 'close':
            status = 'close';
            break;
          case 'closedonarrival':
          case 'minstay':
            status = 'limited';
            break;
        }

        if (!bookingAvailabilityDateStatusMap[hotel]) {
          bookingAvailabilityDateStatusMap[hotel] = [];
        }

        bookingAvailabilityDateStatusMap[hotel][m.format('YYYY-MM-DD')] = status;
      }
    });
  }

  function resetBookingAvailabilityDateStatusMap() {
    const destination = $('#destination-selector').find(':selected');
    const hotel = destination.data('site');
    bookingAvailabilityDateStatusMap[hotel] = [];
    lastRequestedDate = false;
  }

  function showRoomAvailabilityLegend(picker) {
    picker.container.find('.drp-buttons').prepend('<div class="calendar-legend"><span class="calendar-legend__item calendar-legend__item--unavailable"><span></span>unavailable </span>'
      + '<span class="calendar-legend__item calendar-legend__item--restricted"><span></span>restricted</span></div>');
  }

}(jQuery));
/* eslint-enable */

export { updateButtonAvailability };
